import { NotebookIcon } from 'lucide-react';

import { Badge } from 'components/Badge';
import { Checkbox } from 'components/Checkbox';
import { Flex } from 'components/layout';
import { Typography } from 'components/typography';
import { cn } from 'utils/shadcn';

type NoteCardProps = {
  index: number;
  text: string;
  isPriority: boolean;
  cardKey: string;
};

export function NoteCard({ index, text, isPriority, cardKey }: NoteCardProps) {
  return (
    <div
      className={cn(
        'w-full rounded-lg border border-neutral-200 bg-neutral-50 p-4 shadow-sm',
        'dark:border-neutral-700 dark:bg-neutral-800/50'
      )}
    >
      <Flex align='center' justify='between' gap='sm' className='mb-3'>
        <Flex align='center' gap='sm' className='min-w-0'>
          <NotebookIcon
            className='h-4 w-4 shrink-0 text-neutral-500'
            strokeWidth={1.5}
          />
          <Typography
            variant='body-sm'
            weight='semibold'
            className='text-neutral-900 dark:text-neutral-100'
          >
            Note {index + 1}
          </Typography>
        </Flex>
        {isPriority ? (
          <Badge
            variant='default'
            className='shrink-0 text-[10px] bg-warning-50 border-warning text-warning'
          >
            Priority
          </Badge>
        ) : null}
      </Flex>

      <div className='w-full'>
        <Typography variant='body-xs' className='text-neutral-500 mb-1.5 block'>
          Note
        </Typography>
        <div
          className={cn(
            'min-h-[4.5rem] w-full rounded border border-input-border bg-input-bg px-3 py-2.5',
            'read-only:border-neutral-200 read-only:bg-neutral-100'
          )}
        >
          <Typography
            variant='body-sm'
            className='text-neutral-900 leading-relaxed whitespace-pre-wrap break-words dark:text-neutral-100'
          >
            {text}
          </Typography>
        </div>
      </div>

      <Flex
        align='center'
        className='mt-3 pt-3 border-t border-neutral-200 dark:border-neutral-700'
      >
        <Checkbox
          id={`transportpro-priority-note-${cardKey}`}
          label='Priority note'
          labelClassName='text-neutral-600 text-sm'
          checked={isPriority}
          disabled
          className={cn(
            isPriority &&
              'data-[state=checked]:bg-warning data-[state=checked]:border-warning'
          )}
        />
      </Flex>
    </div>
  );
}
